import { Routes, RouterModule } from '@angular/router';
import { PortalAuthGuard }  from '../services/portal-authguard';
import { AssemblyComponent } from '@pershing/nxd-page-assembly-core';
const PAGE_ASSEMBLY_COMPONENT: any = AssemblyComponent;
const appRoutes: Routes = [
  // { path: 'nxi/login',  loadChildren: '@pershing/nxi-login-app#LoginAppModule'},
  // { path: 'nxi/login',  component: PAGE_ASSEMBLY_COMPONENT },
   { path: 'nxi', redirectTo: 'nxi/welcome', pathMatch: 'full' },
   { path: '', redirectTo: 'nxi/welcome', pathMatch: 'full' },
   { path: 'nxi/login', redirectTo: 'nxi/welcome', pathMatch: 'full' },
  {
    path: 'nxi/:firstlevel', component: PAGE_ASSEMBLY_COMPONENT,
    children: [
      {
        path: ':secondlevel', component: PAGE_ASSEMBLY_COMPONENT,
        children: [
          {
            path: ':thirdlevel', component: PAGE_ASSEMBLY_COMPONENT, children: [
              { path: ':fourthlevel', component: PAGE_ASSEMBLY_COMPONENT }
            ]
          }
        ]
      }
    ],
    canActivate: [ PortalAuthGuard],
    canActivateChild: [PortalAuthGuard]
  }
];

export const APP_ROUTES: any = RouterModule.forRoot(appRoutes);
